import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import { environment } from './environments/environment';

// 09.03.2026 lr 624141 disable console logs in production release environment
if (environment.production === true && environment.preview === false) {
  const methods = ['log', 'debug', 'info', 'warn', 'error'] as const;
  methods.forEach((ele) => {
    (console as any)[ele] = () => {};
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
